import { capture } from "./client";
import { FORWARDED_EVENTS } from "./events";

/**
 * Bridge `trackEvent()` (src/lib/audit.ts) → PostHog without touching any
 * existing call site. `trackEvent` already dispatches a `vs:event`
 * CustomEvent on `window`; we listen and forward the allow-listed names.
 */
let attached = false;

export function attachAuditBridge(): void {
  if (attached) return;
  if (typeof window === "undefined") return;
  attached = true;
  window.addEventListener("vs:event", (e: Event) => {
    const detail = (e as CustomEvent<{ event_type?: string; event_data?: Record<string, unknown> }>).detail;
    const name = detail?.event_type;
    if (!name || !FORWARDED_EVENTS.has(name)) return;
    capture(name, detail?.event_data ?? {});
  });
}